import React, { FunctionComponent } from 'react';
import { Flex, Box } from 'rebass/styled-components';
import { Button } from '..';

export interface DefaultButtonsProps {
  editContext: () => void;
  deleteContext: () => void;
  isDeleting: boolean;
  disabled?: boolean;
}

const DefaultButtons: FunctionComponent<DefaultButtonsProps> = (
  {
    editContext, deleteContext, isDeleting, disabled = false,
  }: DefaultButtonsProps,
) => (
  <Flex flex={1} ml={2}>
    <Box mr={2}>
      <Button variant="secondary" onClick={editContext} data-testid="edit-button" disabled={disabled}>
        Edit
      </Button>
    </Box>
    <Button variant="secondary" onClick={deleteContext} data-testid={`${isDeleting ? 'deleting' : 'delete'}-button`}>
      {isDeleting ? 'Deleting' : 'Delete'}
    </Button>
  </Flex>
);

export default DefaultButtons;
